import React from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import { IItemsData } from "./ProductSync";
import NoImageIcon from "../../assets/images/no-image-icon.png";
import moment from "moment";

const SyncedItem = ({
  itemsData,
  classes,
  plu,
}: {
  itemsData: IItemsData;
  classes: any;
  plu: string;
}) => {
  console.log(itemsData);
  var syncedItemPluList:any
  var syncedItemPlist:any
  var syncedItemProductList:any
  if(itemsData.P_Itemlist[0].PRD_POS_REF!=null){
    syncedItemPluList = itemsData.P_Plulist.find(
      (item) => itemsData.P_Itemlist[0].PRD_ITEM_CODE === item.PP_ITEM_CODE
    );
     syncedItemPlist = itemsData.P_Plist.find(
      (item) => syncedItemPluList?.PP_UOM_CODE === item.PL_UOM_CODE
    );
     syncedItemProductList = itemsData.P_Itemlist.find(
      (item) => syncedItemPluList?.PP_ITEM_CODE === item.PRD_ITEM_CODE
    );
  }else{
    syncedItemPluList = itemsData.P_Plulist.find(
      (item) => plu === item.PP_PLU_CODE
    );
     syncedItemPlist = itemsData.P_Plist.find(
      (item) => syncedItemPluList?.PP_UOM_CODE === item.PL_UOM_CODE
    );
     syncedItemProductList = itemsData.P_Itemlist.find(
      (item) => syncedItemPluList?.PP_ITEM_CODE === item.PRD_ITEM_CODE
    );
  }
   
 
  return (
    <Grid item xs={12} sm={12}>
      <Box
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          columnGap: 20,
        }}
      >
        <img
          // src="https://images.unsplash.com/photo-1576834975354-ee694be1f0d1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
          src={NoImageIcon}
          alt={syncedItemProductList?.PRD_ITEM_NAME ?? "item"}
          height={200}
          width={200}
          style={{ padding: "10px", border: "1px solid gray" }}
        />
        <Box flexGrow={1}>
          <Typography align="left" variant="h5" color="primary" gutterBottom>
            <Box fontWeight="fontWeightBold">
              {syncedItemProductList?.PRD_ITEM_NAME ?? "-"}
            </Box>
          </Typography>
          <table style={{ borderCollapse: "collapse" }}>
            <tbody>
              <tr>
                <td className={classes.itemRowCell} width="40%" align="left">
                  Barcode
                </td>
                <td className={classes.itemRowCell} align="left">
                  : {syncedItemPluList?.PP_PLU_CODE ?? "-"}
                </td>
              </tr>
              <tr>
                <td className={classes.itemRowCell} width="40%" align="left">
                  Name
                </td>
                <td className={classes.itemRowCell} align="left">
                  : {syncedItemProductList?.PRD_ITEM_NAME_FL ?? "-"}
                </td>
              </tr>
              <tr>
                <td className={classes.itemRowCell} width="40%" align="left">
                  Item code
                </td>
                <td className={classes.itemRowCell} align="left">
                  : {syncedItemProductList?.PRD_ITEM_CODE ?? "-"}
                </td>
              </tr>
              <tr>
                <td className={classes.itemRowCell} width="40%" align="left">
                  Item type
                </td>
                <td className={classes.itemRowCell} align="left">
                  : {syncedItemProductList?.PRD_ITEM_TYPE ?? "-"}
                </td>
              </tr>
              <tr>
                <td className={classes.itemRowCell} width="40%" align="left">
                  Uom
                </td>
                <td className={classes.itemRowCell} align="left">
                  : {syncedItemProductList?.PRD_UOM_CODE ?? "-"}
                </td>
              </tr>
              <tr>
                <td className={classes.itemRowCell} width="40%" align="left">
                  Category
                </td>
                <td className={classes.itemRowCell} align="left">
                  : {syncedItemProductList?.PRD_ITEM_MODE ?? "-"}
                </td>
              </tr>
              <tr>
                <td className={classes.itemRowCell} width="40%" align="left">
                  Rate
                </td>
                <td className={classes.itemRowCell} align="left">
                  : {syncedItemPlist?.PL_RATE ?? "-"}
                </td>
              </tr>
              <tr>
                <td className={classes.itemRowCell} width="40%" align="left">
                  Last updated
                </td>
                <td className={classes.itemRowCell} align="left">
                  :{" "}
                  {syncedItemProductList?.PRD_LAST_UPD_DT
                    ? moment(syncedItemProductList.PRD_LAST_UPD_DT).format(
                        "DD MMM YYYY"
                      )
                    : "-"}
                </td>
              </tr>
            </tbody>
          </table>
        </Box>
      </Box>
    </Grid>
  );
};

export default SyncedItem;
